export enum EnumQuestionType {
    Select = "Select",
    Text = "Text",
    RadioButton = "RadioButton",
}
